import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/716-cannabis/components/ui/direct-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/716-cannabis/node_modules/next/dist/client/app-dir/link.js");
